import config from 'config';
import * as configcat from 'configcat-js';

import type { Flags } from './feature-toggle';

type UserObject = {
  identifier: string;
  email: string;
  country: string;
  custom: {
    SubscriptionType: string;
    UserRole: string;
  };
};

type SettingValue = string | boolean | number | undefined | null;

type GetFeatureFlag = {
  flag: Flags;
  defaultValue: SettingValue;
  userObject?: UserObject;
};

type GetFeatureFlagSpecificUser = {
  flag: Flags;
  defaultValue: SettingValue;
  resellerId?: string;
};

class MyCustomCache implements configcat.IConfigCatCache {
  set(key: string, value: string): Promise<void> | void {
    window.localStorage.setItem(key, JSON.stringify(value));
  }

  get(key: string): Promise<string | null | undefined> | string | null | undefined {
    try {
      const cacheData = window.localStorage.getItem(key);
      return JSON.parse(String(cacheData));
    } catch (error) {
      return null;
    }
  }
}

const configCatClient = configcat.getClient(
  config?.configCat?.sdkKey || '',
  configcat.PollingMode.AutoPoll,
  {
    pollIntervalSeconds: 10 * 60, // 10 min
    cache: new MyCustomCache(),
  },
);

export const getFeatureFlag = async ({
  flag,
  defaultValue,
  resellerId,
}: GetFeatureFlagSpecificUser) => {
  if (resellerId) {
    const userObject = new configcat.User(resellerId);
    const result = await configCatClient.getValueAsync(flag, defaultValue, userObject);
    return result;
  }

  const result = await configCatClient.getValueAsync(flag, defaultValue);

  return result;
};
